import EntityFactory from './factory/entityFactory.service';
import EntityIdentifier from './factory/entityIdentifier.service';
import HalService from './hal/hal.service';
import HeaderService from './headers/header.service';
import JwtService from './headers/jwt.service';
import EntityService from './manager/entity.service';
import EntityManager from './manager/entityManager.service';
import EntitySubjectPool from './manager/entitySubjectPool.service';
import StorageService from './storage/storage.service';
import EntityStore from './store/entityStore.service';
import LocalEntityStore from './store/localEntityStore.service';
import RemoteEntityStore from './store/remoteEntityStore.service';
import EncryptionService from './encryption/encryption.service';
import LanguageService from './language/language.service';
import ApplicationVersionService from './applicationVersion.service';
import ConfigurationService from './config/configuration.service';
import NetworkService from './network/network.service';
import PlatformService from './platform/platform.service';
import MobilePlatformService from './platform/mobilePlatform.service';
import WebPlatformService from './platform/webPlatForm.service';
export const initialize = () => {
    let entityManager;
    const contructEntityManager = () => {
        const configurationService = new ConfigurationService();
        const networkService = new NetworkService(configurationService);
        const platformService = new PlatformService();
        const mobilePlatformService = new MobilePlatformService(configurationService);
        const webPlatformService = new WebPlatformService(configurationService);
        const storageService = new StorageService(configurationService);
        const applicationVersionService = new ApplicationVersionService(configurationService, storageService);
        const encryptionService = new EncryptionService(configurationService);
        const languageService = new LanguageService(configurationService);
        const jwtService = new JwtService(configurationService, storageService, platformService);
        const entityIdentifier = new EntityIdentifier(platformService);
        const entityFactory = new EntityFactory(entityIdentifier, configurationService);
        const halService = new HalService(entityIdentifier);
        const headerService = new HeaderService(jwtService, languageService, platformService, mobilePlatformService, webPlatformService);
        const remoteEntityStore = new RemoteEntityStore(headerService, configurationService, networkService);
        const localEntityStore = new LocalEntityStore(configurationService, encryptionService, storageService);
        const entitySubjectPool = new EntitySubjectPool();
        const entityStore = new EntityStore(halService, entityIdentifier, localEntityStore, remoteEntityStore);
        const entityService = new EntityService(entityFactory, entitySubjectPool, entityStore, applicationVersionService, entityIdentifier);
        entityManager = new EntityManager(entityService, configurationService);
        return entityManager;
    };
    return entityManager === undefined ? contructEntityManager() : entityManager;
};
